/**
 * A license is good through its expiry day: expired only once that calendar day is before
 * `today`, the Pacific business date. No expiry date never expires.
 */
export function isLicenseExpired(expiresAt, today) {
    return expiresAt !== null && expiresAt < today;
}
//# sourceMappingURL=is-license-expired.js.map